export default "__VITE_ASSET__BwzOhpkw__"